module.exports = __webpack_public_path__ + "static/media/isa4.ed3e4ad6.png";